App.SettingsBillingTariffsController = Em.Controller.extend
  notifier: Em.inject.service('notifier')
  env:      Em.inject.service('environment')

  needs: [ 'settingsBilling' ]

  billingBinding: 'controllers.settingsBilling'
  billingInfoBinding: 'controllers.settingsBilling.billingInfo'

  tariffsBinding: 'billing.filteredTariffs'
  tariffsSortOrder: [ 'month_price' ]
  sortedTariffs: Em.computed.sort('tariffs', 'tariffsSortOrder')

  selectedTariff: null

  # Выбран тариф, на который уже подписаны
  alreadySubscribed: (->
    lhs = @get('selectedTariff.id')
    rhs = @get('billing.currentTariff.service.id')
    lhs is rhs
  ).property(
    'selectedTariff.id',
    'billing.currentTariff.service.id')

  # Принят ли пейвол. Влияет поведение при выборе тарифного плана
  paywallAccepted: Em.computed.alias('billingInfo.paywall_accepted')

  # Кнопка выбора показана всегда, если paywall не принят
  # В остальных случаях только если еще не подписаны на этот тариф
  showApplyButton: (->
    !@get('paywallAccepted') or !@get('alreadySubscribed')
  ).property(
    'alreadySubscribed'
    'paywallAccepted')

  # Дата вступления в силу тарифного плана
  # в случае выбора плана с пейволом
  dateOffer: Em.computed.alias('billingInfo.paywall_deadline')

  # Чекбокс принятия условий показывается, если выбран небесплатный тариф
  # и пейвол не был принят
  showOfferCheckbox: Ember.computed [
    'paywallAccepted',
    'selectedTariff.isFree',
    'billing.currentTariff.service.isFree',
  ]..., ->
    !@get('paywallAccepted') and
    !@get('selectedTariff.isFree')


  disabledApplyButton: Ember.computed 'showOfferCheckbox', 'offerChecked', ->
    @get('showOfferCheckbox') and not @get('offerChecked') or not @get('selectedTariff.name')

  # текст для кнопки смены тарифа
  applyTariffText: (->
    tariffName      = @get('selectedTariff.name')
    paywallAccepted = @get('billingInfo.paywall_accepted')

    if paywallAccepted
      return @get('env').translate('billing.tariffs.change_tariff.plain', tariff_name: tariffName)
    else
      if @get('billingInfo.beforePaywallDeadline')
        if tariffName
          "#{@get('env').translate('billing.tariffs.change_tariff.paywall_before_deadline')} «#{tariffName}»"
        else
          @get('env').translate('billing.tariffs.change_tariff.paywall_before_deadline')
      else
        if tariffName
          "#{@get('env').translate('billing.tariffs.change_tariff.paywall')} «#{tariffName}»"
        else
          @get('env').translate('billing.tariffs.change_tariff.paywall')
  ).property(
    'selectedTariff.name',
    'billingInfo.beforePaywallDeadline',
    'billingInfo.paywall_accepted')

  isLoading: false

  offerChecked: null


  actions:
    closeModal: ->
      @transitionToRoute 'settings.billing'
      false

    applyTariff: ->
      if @get('controllers.settingsBilling.isPaymentMethodNotSet')
        @transitionToRoute('settings.billing.payment_method')
        return

      @set('isLoading', true)

      targetTariff     = @get('selectedTariff')
      currentTariffSub = @get('billing.currentTariff')

      billingInfo = @get('billingInfo')

      switchTariff = =>
        if @get('alreadySubscribed')
          return Em.RSVP.resolve()

        currentTariffSub.switchTariff(targetTariff)
        .then =>
          currentTariffSub.deleteRecord()
          @get('billing').set('subscriptions', Em.A())
          @store.find('service_subscription')
        .then (subs) =>
          @get('billing').set('subscriptions', subs)


      billingInfo.acceptPaywall()
      .then =>
        switchTariff()
      .then =>
        @get('billingInfo').reload()
      .then =>
        @set('isLoading', false)
        @transitionToRoute('settings.billing')
        @get('controllers.settingsBilling').set('billingOperations', @store.find('billing_operation'))
      .catch (e) =>
        @get('billingInfo').reload()
        error = e.responseJSON?.error
        if error
          @get('notifier').pushNotification
            type: 'error'
            title:   @get('env').translate('billing.notifications.change_tariff_error')
            message: error
            duration: 5000

        @set('isLoading', false)


      false
